import ApiService from "./api.service";
import UtilService from "./util.service";

const BULK_PAYOUT_BATCH_ROW_ERROR_BASE_PATH = "/api/bulkPayoutBatchRowErrors";

const BulkPayoutBatchRowErrorService = {
  search(filters, options = {}) {
    const params = UtilService.buildPaginationParams(options);
    return ApiService.post(`${BULK_PAYOUT_BATCH_ROW_ERROR_BASE_PATH}/search?${params.toString()}`, filters || {});
  }
};

export default BulkPayoutBatchRowErrorService;
